﻿{
  "community": {
    "name": "Community",
    "titles": {
      "1": "Online-community",
      "2": "Hitta material",
      "3": "Dela det du har skapat"
    },
    "body": {
      "1": "Ett bra ställe att  hoppa in och kolla allt som Boardmaker erbjuder",
      "2": "Se vad andra skapar och delar Det är som ett fönster mot Boardmakers magi!",
      "3": "Använd den Boardmaker-mjukvara du föredrar, ladda upp och dela det du har skapat med vår community"
    }
  },
  "personal": {
    "name": "Personlig prenumeration",
    "header": "Inkluderar allt i Community plus:",
    "titles": {
      "1": "Skapa, redigera, spela och skriv ut",
      "2": "Boardmaker mjukvara"
    },
    "body": {
      "1": "För föräldrar eller vårdhavare med ett barn som vill skapa, redigera, spela och skriva ut aktiviteter",
      "2": "Med kontot följer en Boardmaker 7-licens som kan installeras på upp till två Windows-datorer"
    }
  },
  "professional": {
    "name": "Professionell prenumeration",
    "header": "Inkluderar allt i Personlig prenumeration plus:",
    "titles": {
      "1": "Administration av elever",
      "2": "Individanpassade inställningar"
    },
    "body": {
      "1": "För instruktörer med 1 till 50 elever som vill tilldela uppgifter och spåra elevdata",
      "2": "Anpassade åtkomstinställningar för individuella elever"
    }
  },
  "organization": {
    "name": "Verksamhetsprenumeration",
    "header": "Inkluderar allt i Professionell prenumeration plus:",
    "titles": {
      "1": "Stöd för team inom många discipliner"
    },
    "body": {
      "1": "Volymprissättning, organisationen kontrollerar informationen och flera personer kan tilldela till samma elev"
    }
  }
}
